const devices = {
  name: 'Dispositivo |||| Dispositivos',
  list: {
    title: 'Listado de Dispositivos',
    empty: 'No hay dispositivos registrados',
  },
  create: {
    title: 'Crear Dispositivo',
    subtitle: 'Registrar un nuevo dispositivo en el sistema',
  },
  edit: {
    title: 'Editar Dispositivo',
  },
  fields: {
    installationCode: 'Código de Instalación',
    hotel: 'Instalación',
    group: 'Grupo',
    deviceType: 'Tipo de Dispositivo',
    channel: 'Canal',
    status: 'Estado',
    source: 'Origen',
    serialNumber: 'Número de Serie',
    name: 'Nombre',
    metadata: 'Metadatos',
    registeredAt: 'Fecha de Registro',
    lastSeenAt: 'Última Conexión',
    apiKey: 'Clave API',
    category: 'Categoría',
  },
  // Labels for raw metadata keys surfaced in the device list/detail (F-B-014):
  // no internal product name may reach the UI verbatim. Unmapped keys fall
  // back to a humanised version of the key itself (see DeviceList.tsx).
  metadataKeys: {
    deviceId: 'ID de dispositivo',
    establishmentId: 'ID de instalación',
    groupId: 'ID de grupo',
    model: 'Modelo',
    firmware: 'Firmware',
  },
  // Compact presence indicator for the metadata column (F-B-015): the full
  // pairs live in the device detail (DeviceEdit.tsx).
  metadataCount: '%{smart_count} valor |||| %{smart_count} valores',
  filters: {
    search: 'Buscar por código',
    hotel: 'Instalación',
    group: 'Grupo',
    deviceType: 'Tipo',
    status: 'Estado',
    source: 'Origen',
    channel: 'Canal',
    metadataKey: 'Clave de Metadata',
    metadataValue: 'Valor de Metadata',
    metadataSearch: 'Buscar por Metadata',
    metadataSearchHint: 'Introduzca clave y valor para buscar',
  },
  actions: {
    create: 'Crear Dispositivo',
    showApiKey: 'Mostrar Clave API',
    hideApiKey: 'Ocultar Clave API',
    deactivate: 'Desactivar',
    forceDelete: 'Eliminar Permanentemente',
    forceDeleteConfirm: 'Eliminar Definitivamente',
    generateOtp: 'Generar OTP',
    copyOtp: 'Copiar',
    viewLogs: 'Ver registros',
  },
  sections: {
    basicInfo: 'Información Básica',
    assignment: 'Asignación',
    readOnlyInfo: 'Información del Dispositivo',
    readOnlySubtitle: 'Consulte los detalles e información de registro del dispositivo',
    editableFields: 'Campos Editables',
    editableSubtitle: 'Modifique la asignación y estado del dispositivo',
  },
  hints: {
    installationCode: 'Introduzca el código de instalación del dispositivo',
    groupOptional: 'Opcionalmente asigne a un grupo',
    changeHotel: 'Cambiar la asignación de instalación',
    changeGroup: 'Cambiar la asignación de grupo',
    changeStatus: 'Cambiar el estado del dispositivo',
    changeChannel: 'Cambiar el canal del dispositivo',
    deviceType: 'Seleccione el tipo de dispositivo',
    channel: 'Seleccione el canal de comunicación',
    category: 'Seleccione la categoría del dispositivo',
    serialNumber: 'Número de serie del hardware (necesario para generar OTP)',
    name: 'Nombre descriptivo opcional para este dispositivo',
  },
  messages: {
    createInfo: 'Complete la información para registrar un nuevo dispositivo',
    createWarning: 'El dispositivo se creará en estado pendiente de activación',
    createSuccess: 'Dispositivo creado correctamente',
    editInfo: 'Modifique los campos editables del dispositivo',
    updateSuccess: 'Dispositivo actualizado correctamente',
    deactivateConfirm: '¿Está seguro de que desea desactivar este dispositivo?',
    deactivateWarning: 'El dispositivo ya no podrá acceder al sistema',
    deactivateInfo: 'Dispositivo desactivado correctamente',
    alreadyInactive: 'El dispositivo ya está inactivo',
    deleteError: 'Error al desactivar el dispositivo',
    // Force delete messages
    forceDeleteCaption: 'Eliminar dispositivo y todos sus datos',
    forceDeleteConfirm: 'Eliminar Dispositivo Permanentemente',
    forceDeleteDanger: 'Esta acción es IRREVERSIBLE y eliminará TODOS los datos permanentemente.',
    forceDeleteWarning: '¿Está seguro de que desea eliminar permanentemente el dispositivo "%{installationCode}" y TODOS sus datos asociados?',
    forceDeleteWillRemove: 'Esto eliminará permanentemente',
    forceDeleteComplete: 'El dispositivo y todos sus datos asociados han sido eliminados permanentemente.',
    forceDeleteSummary: 'Resumen de eliminación',
    forceDeleteSuccess: 'Dispositivo eliminado permanentemente',
    forceDeleteError: 'Error al eliminar el dispositivo',
    allJourneys: 'Todos los journeys de check-in',
    allEvents: 'Todos los eventos y errores',
    theDevice: 'El dispositivo en sí',
    deletedJourneys: 'Journeys eliminados',
    deletedEvents: 'Eventos eliminados',
    deletedDevices: 'Dispositivos eliminados',
    otpTitle: 'Código OTP',
    otpOperator: 'Operator',
    otpSettings: 'Settings',
    otpValidFor: 'Válido para el día',
    otpNoSerialNumber: 'Este dispositivo no tiene número de serie configurado.',
    otpConfigureFirst: 'Configurar ahora',
    otpCopied: 'OTP copiado al portapapeles',
    otpError: 'Error al generar OTP',
    otpDate: 'Fecha',
  },
  categories: {
    kiosk_onpremise: 'Kiosco On-Premise',
    kiosk_online: 'Kiosco Online',
    guest_mobile: 'Móvil Huésped',
    online_checkin: 'Check-in Online',
    mobile_desk: 'Mesa Móvil',
    dispenser: 'Dispensador',
  },
  enums: {
    deviceType: {
      kiosk: 'Kiosco',
      dispenser: 'Dispensador',
      mobile: 'Móvil',
      online: 'Online',
      virtual: 'Virtual',
    },
    channel: {
      kiosk: 'Kiosco',
      dispenser: 'Dispensador',
      online: 'Online',
      airLobby: 'Air Lobby',
      airlobby: 'Air Lobby',
      mobileKiosk: 'Kiosco móvil',
      mobilekiosk: 'Kiosco móvil',
      virtual: 'Virtual',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
      pendingActivation: 'Pendiente de Activación',
      pendingactivation: 'Pendiente de Activación',
    },
    source: {
      updater: 'Updater',
      manual: 'Manual',
    },
  },
  logs: {
    title: 'Registros del dispositivo',
    subtitle: 'Registros de %{code}',
    backToDevices: 'Volver a dispositivos',
    noLogs: 'No se encontraron registros para este dispositivo',
    noLogsHint: 'Es posible que el dispositivo aún no haya enviado registros, o que el servidor de registros no esté disponible.',
    seqError: 'No se pudieron obtener los registros del dispositivo',
    level: 'Nivel',
    allLevels: 'Todos los niveles',
    from: 'Desde',
    to: 'Hasta',
    count: 'Máx. resultados',
    refresh: 'Actualizar',
    component: 'Componente',
    origin: 'Origen',
    firmware: 'Firmware',
    serialNumber: 'Número de serie',
    result: 'Resultado',
    transaction: 'Transacción',
    steps: 'Pasos',
    step: 'Paso %{number}',
    properties: 'Propiedades',
    loading: 'Cargando registros...',
  },

  // Connectivity board (public panel-link "Equipos" tab, `DeviceDashboardView`)
  dashboardView: {
    empty: 'No hay equipos para mostrar.',
    filter: {
      all: 'Todos (%{count})',
      connected: 'Conectados (%{count})',
      disconnected: 'Desconectados (%{count})',
    },
  },
};
export default devices;